import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService } from '../../services/user.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { User } from '../../models/user.model';
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableResponsiveModule } from '../../mat-table-responsive.module';

@Component({
  selector: 'app-admins',
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    CommonModule,
    MatTableResponsiveModule,
  ],
  templateUrl: './admins.component.html',
  styleUrl: './admins.component.scss',
})
export class AdminsComponent implements OnInit {
  loading: boolean = false;
  displayedColumns: string[] = ['name', 'email'];
  dataSource = new MatTableDataSource<User>([]);
  totalCount: number = 0;
  queryParams = new Map<string, any>();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  page = {
    countRequested: 5,
    pageIndex: 1,
    items: [],
    totalCount: 0,
  };

  constructor(
    private userService: UserService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.queryParams.set('Role', 'Admin');

    this.userService
      .getAll(this.page.pageIndex, this.page.countRequested, this.queryParams)
      .subscribe({
        next: (response) => {
          this.dataSource = new MatTableDataSource(response.items);
          this.dataSource.paginator = this.paginator;
        },
      });
  }

  changePage(event: PageEvent): void {
    this.loading = true;
    this.page.countRequested = event.pageSize;
    this.page.pageIndex == event.pageIndex + 1;
    this.userService
      .getAll(event.pageIndex + 1, event.pageSize, this.queryParams)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.dataSource = new MatTableDataSource(response.items);
          this.totalCount = response.totalCount;
        },
        error: () => {
          this.snackBar.open(
            'An error occured while retrieving users. Please try again.',
            '',
            { duration: 3000 }
          );
        },
      });
  }
}
